export default __webpack_public_path__ + "static/media/210430-Cloudxier Clients Logo-21.d467a0bc.png";